import { mixed, object, string, boolean, array } from 'yup'

import { CompanyBusinessSegmentType } from '~api/models'
import { mandatoryField } from '~shared/translations/yupSchemaErrors'
import { NewUserStep2Extended } from '~app/screens/RegistrationCustomerPortal/components/NewUserFormWizard/screens/step2/useStep2'

export const NewUserStep2Schema = object<NewUserStep2Extended>({
  name: string().required(mandatoryField),
  streetAndNumber: string().required(mandatoryField),
  zip: string().required(mandatoryField),
  city: string().required(mandatoryField),
  country: string().required(mandatoryField),
  phone: string().required(mandatoryField),
  segments: array().of<CompanyBusinessSegmentType>(mixed<CompanyBusinessSegmentType>()).required(mandatoryField),
  vatId: string(),
  acceptPrivacyPolicy: boolean().required(mandatoryField).oneOf([true], mandatoryField),
}).defined()
